(() => {
  const stage = document.getElementById('reel-stage');
  if (!stage) return;

  const films = window.UAE_FILMS || [];

  const title = document.getElementById('reel-title');
  const description = document.getElementById('reel-description');
  const modelLink = document.getElementById('reel-3d-link');
  const productLink = document.getElementById('reel-product-link');
  const previous = document.getElementById('reel-prev');
  const next = document.getElementById('reel-next');
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const gsapReady = typeof window.gsap !== 'undefined';
  const cards = films.map((film, index) => {
    const card = document.createElement('div');
    card.className = 'portrait-gallery__card';
    card.dataset.index = index;
    card.setAttribute('aria-label', film.name + ' video');
    card.innerHTML = `<video muted playsinline loop preload="none" poster="${film.poster}" aria-label="${film.name}"><source src="${film.video}" type="video/mp4"></video><button class="portrait-gallery__play" type="button" aria-label="Pause ${film.name} video">Pause film</button>`;
    card.addEventListener('click', event => {
      if (event.target.closest('.portrait-gallery__play')) return;
      if (index !== current) show(index);
    });
    const playButton = card.querySelector('button');
    const video = card.querySelector('video');
    playButton.addEventListener('click', event => {
      event.stopPropagation();
      if (video.paused) video.play().catch(() => {});
      else video.pause();
      syncPlayLabel();
    });
    video.addEventListener('play', syncPlayLabel);
    video.addEventListener('pause', syncPlayLabel);
    stage.append(card);
    return card;
  });
  let current = 1;
  let wheelTime = 0;
  let touchStart = null;
  let visible = false;

  function syncPlayLabel() {
    cards.forEach((card, index) => {
      const video = card.querySelector('video');
      const button = card.querySelector('button');
      button.textContent = video.paused ? 'Play film' : 'Pause film';
      button.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} ${films[index].name} video`);
    });
  }

  function coordinates(offset) {
    const step = Math.min(stage.clientWidth * .4, 300);
    if (offset === 0) return { x: 0, z: 0, rotationY: 0, scale: 1, opacity: 1 };
    const direction = Math.sign(offset);
    if (Math.abs(offset) === 1) return { x: direction * step, z: -190, rotationY: -direction * 26, scale: .78, opacity: .77 };
    return { x: direction * step * 1.6, z: -380, rotationY: -direction * 42, scale: .54, opacity: 0 };
  }

  function positionCard(card, index, animate) {
    const offset = index - current;
    const state = coordinates(offset);
    card.classList.toggle('is-active', offset === 0);
    card.style.zIndex = String(20 - Math.abs(offset));
    card.style.pointerEvents = Math.abs(offset) <= 1 ? 'auto' : 'none';
    card.setAttribute('aria-hidden', Math.abs(offset) > 1 ? 'true' : 'false');
    card.querySelector('button').tabIndex = offset === 0 ? 0 : -1;
    if (gsapReady) {
      window.gsap.to(card, {
        ...state, xPercent: -50, yPercent: -50,
        duration: animate && !reduceMotion.matches ? .72 : 0,
        ease: 'power3.inOut', overwrite: true
      });
    } else {
      card.style.transition = animate && !reduceMotion.matches ? 'transform .72s cubic-bezier(.22,.68,0,1), opacity .72s' : 'none';
      card.style.transform = `translate(-50%, -50%) translateX(${state.x}px) translateZ(${state.z}px) rotateY(${state.rotationY}deg) scale(${state.scale})`;
      card.style.opacity = state.opacity;
    }
  }

  function playback() {
    cards.forEach((card, index) => {
      const video = card.querySelector('video');
      if (index === current && video.readyState === 0) video.load();
      if (visible && index === current) video.play().catch(() => {});
      else video.pause();
    });
    syncPlayLabel();
  }

  function show(index, animate = true) {
    if (index < 0 || index >= films.length) return;
    current = index;
    const film = films[index];
    title.textContent = film.name;
    description.textContent = film.detail;
    modelLink.href = '#3d-products';
    modelLink.dataset.selectModel = film.model;
    modelLink.hidden = !film.model;
    productLink.hidden = !film.product;
    if (film.product) productLink.href = film.product;
    productLink.textContent = film.productLabel || 'View product ↗';
    previous.disabled = index === 0;
    next.disabled = index === films.length - 1;
    cards.forEach((card, i) => positionCard(card, i, animate));
    playback();
  }

  previous.addEventListener('click', () => show(current - 1));
  next.addEventListener('click', () => show(current + 1));
  stage.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
  });
  stage.addEventListener('wheel', event => {
    const movement = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
    const direction = Math.sign(movement);
    if (!direction || (direction < 0 && current === 0) || (direction > 0 && current === films.length - 1)) return;
    event.preventDefault();
    const now = performance.now();
    if (now - wheelTime < 650) return;
    wheelTime = now;
    show(current + direction);
  }, { passive: false });
  stage.addEventListener('touchstart', event => {
    touchStart = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
  }, { passive: true });
  stage.addEventListener('touchend', event => {
    if (!touchStart) return;
    const dx = event.changedTouches[0].clientX - touchStart.x;
    const dy = event.changedTouches[0].clientY - touchStart.y;
    if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.2) show(current + (dx < 0 ? 1 : -1));
    touchStart = null;
  }, { passive: true });
  addEventListener('resize', () => cards.forEach((card, index) => positionCard(card, index, false)));
  new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    playback();
  }, { threshold: .15 }).observe(stage);
  show(1, false);
})();
